var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoute = function SvgRoute(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7C19.5 8.38071 18.3807 9.5 17 9.5C16.0696 9.5 15.2579 8.99178 14.8274 8.2378C13.7533 8.69437 13 9.75921 13 11V12V13C13 15.288 11.4632 17.2171 9.36542 17.8113C9.02853 18.7938 8.09674 19.5 7 19.5C5.61929 19.5 4.5 18.3807 4.5 17C4.5 15.6193 5.61929 14.5 7 14.5C7.93038 14.5 8.74205 15.0082 9.17255 15.7622C10.2467 15.3056 11 14.2408 11 13V12V11C11 8.71196 12.5368 6.78288 14.6346 6.18872C14.9715 5.20622 15.9033 4.5 17 4.5C18.3807 4.5 19.5 5.61929 19.5 7Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoute);
export default ForwardRef;